import BrandsSlider from "./components/brands-slider";
import CallToAction from "./components/call-to-action";
import ComparisonCards from "./components/comparison-cards";
import Faq from "./components/faq";
import FinishesColors from "./components/finishes-colors";
import FinishesCardsLayout from "./components/finishes-layout";
import FinishesSlider from "./components/finishes-slider";
import MaterialsCard from "./components/materials-card";
import PartsSlider from "./components/parts-slider";
import ReviewsSlider from "./components/reviews-slider";
import SetBgColor from "./components/set-bg-color";
import CheckAndRemoveClasses from "./components/newsletter";
import HowItWorksSlider from "./components/how-it-works-slider";
import HowItWorksSteps from "./components/how-it-works-steps";
import MaterialCards from "./components/material-cards";
import MaterialCardsSlider from "./components/material-cards-slider";
import Selects from "./components/selects";
import CapabilityCards from "./components/capability-cards";
import ComparisonTable from "./components/comparison-table";
import CapabilityTable from "./components/capability-table";
import ProcessSlider from "./components/process-slider";
import Accordion from "./components/accordion";
import CapabilityIconsSlider from "./components/capability-icons-slider";

document.addEventListener("DOMContentLoaded", function () {
  BrandsSlider();
  ComparisonCards();
  CallToAction();
  MaterialsCard();
  FinishesSlider();
  SetBgColor();
  FinishesColors();
  PartsSlider();
  Faq();
  ReviewsSlider();
  CheckAndRemoveClasses();
  FinishesCardsLayout();
  HowItWorksSlider();
  HowItWorksSteps();
  MaterialCards();
  MaterialCardsSlider();
  Selects();
  CapabilityCards();
  ComparisonTable();
  CapabilityTable();
  ProcessSlider();
  Accordion();
  CapabilityIconsSlider();
});

